import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

/* JS */
import * as Server from 'assets/js/Server';

const ProductSearchForm = props => {
  const [warehouseList, setWarehouseList] = useState([{
    warehouseSeq: '',
    warehouseName: '',
  }]);
  const [productTypeList, setProductTypeList] = useState([{
    productTypeMstSeq: '',
    productType: '',
  }]);
  const [productKindList, setProductKindList] = useState([{
    productKindSeq: '',
    productKindName: '',
  }]);

  useEffect(() => {
    getSearchParamList();
  }, []);

  const getSearchParamList = () => {
    Server.sendGet('product/search', props?.search, getSearchParamListCallback).then();
  };

  const getSearchParamListCallback = res => {
    const resultObject = res?.['resultObject'];

    setWarehouseList(resultObject?.['warehouseList']);
    setProductTypeList(resultObject?.['productTypeList']);
    setProductKindList(resultObject?.['productKindList']);
  };

  const onEnter = event => {
    if (event.keyCode === 13) {
      event.preventDefault();

      props?.getList();
    }
  };

  return (
    <>
      <SearchArea>
        <CateIn>
          <Cate>
            <CateSel
              name='warehouseForm'
              id='warehouseForm'
              value={props?.search?.warehouseSeq}
              onChange={e => {
                props?.setSearch(() => {
                  return {
                    ...props?.search,
                    warehouseSeq: e.target.value,
                  };
                });
              }}
            >
              <option value={''}>Warehouse</option>
              {warehouseList?.map(item => (
                <option key={item.warehouseSeq} value={item.warehouseSeq}>{item.warehouseName}</option>
              ))}
            </CateSel>
          </Cate>
          <Cate>
            <CateSel
              name='productTypeForm'
              id='productTypeForm'
              value={props?.search?.productTypeMstSeq}
              onChange={e => {
                props?.setSearch(() => {
                  return {
                    ...props?.search,
                    productTypeMstSeq: e.target.value,
                  };
                });
              }}
            >
              <option value={''}>Product Type</option>
              {productTypeList?.map(item => (
                <option key={item.productTypeMstSeq} value={item.productTypeMstSeq}>{item.productType}</option>
              ))}
            </CateSel>
          </Cate>
          <Cate>
            <CateSel
              name='productKindForm'
              id='productKindForm'
              value={props?.search?.productKindSeq}
              onChange={e => {
                props?.setSearch(() => {
                  return {
                    ...props?.search,
                    productKindSeq: e.target.value,
                  };
                });
              }}
            >
              <option value={''}>Product Kind</option>
              {productKindList?.map(item => (
                <option key={item.productKindSeq} value={item.productKindSeq}>{item.productKindName}</option>
              ))}
            </CateSel>
          </Cate>
          <Cate>
            <CateInput
              placeholder='Product Name'
              type={'text'}
              id={'productName'}
              value={props?.search?.productName}
              onChange={e => {
                props?.setSearch(() => {
                  return {
                    ...props?.search,
                    productName: e.target.value,
                  }
                });
              }}
              onKeyDown={(event) => {
                onEnter(event);
              }}
            />
          </Cate>
        </CateIn>
        <SearchBtn onClick={props?.getList}>Search</SearchBtn>
      </SearchArea>
    </>
  )
}

const SearchArea = styled.div`
  position: relative;
  margin-top: 35px;
  padding: 15px 20px;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  gap: 0 15px;
  width: 100%;

  & .react-datepicker__tab-loop {
    position: absolute;
  }
`;

const CateIn = styled.div`
  display: flex;
  align-items: center;
  gap: 0 20px;
`;

const Cate = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & label {
    font-weight: 400;
    font-size: 16px;
    color: #777777;
  }
`;

const CateSel = styled.select`
  width: 200px;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  font-weight: 400;
  font-size: 16px;
  color: #777777;
  background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  outline: none;
`;

const CateInput = styled.input`
  width: 160px;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  font-weight: 400;
  font-size: 16px;
  color: #777777;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  outline: none;
`;

const SearchBtn = styled.button`
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: #a4a4a4;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;

  &:hover {
    background-color: #7e7e7e;
  }
`;

export default ProductSearchForm;